import React, {useReducer} from 'react';
import clienteAxios from '../../config/axios';

import consumoContext from './consumoContext';
import consumoReducer from './consumoReducer';

import { 
    AGREGAR_CONSUMO,
    OBTENER_CONSUMOSPYT,
    ELIMINAR_CONSUMO,
    OBTENER_CONSUMO_ED,
    EDITAR_CONSUMO
} from "../../types";

const ConsumoState = props => {

    const initialState = {
        consumosproyecto: [],
        consumoeditar: null
    }

    // dispatch para ejecutar las acciones
    const [state, dispatch] = useReducer(consumoReducer, initialState)

    // serie de funciones para el CRUD

    // Obtener los consumos proyecto
    const obtenerConsumosPyt = async proyecto => {
      try {
        const resultado = await clienteAxios.get('/api/consumos', {params: {proyecto}})
        //console.log(resultado);
        dispatch({
            type: OBTENER_CONSUMOSPYT,
            payload: resultado.data.consumos
        })
      } catch (error) {
        console.log(error);
      }
        
    }

    // agregar nuevo consumo
    const agregarConsumo = async consumo => {
        try {
          consumo.consumoE = consumo.potencia * consumo.uso 
          const resultado = await clienteAxios.post('/api/consumos', consumo);
          console.log(resultado);
          
          // insertar consumo en el state
          dispatch({
              type: AGREGAR_CONSUMO,
              payload: resultado.data.consumo
          })
        } catch (error) {
          console.log(error);
        }
        
    }

    // selecciona y elimina un consumo
    const eliminarConsumo = async (id, proyecto) => {
      try {
        await clienteAxios.delete(`/api/consumos/${id}`, {params: {proyecto}})
        dispatch({
          type: ELIMINAR_CONSUMO,
          payload: id
        })
      } catch (error) {
        console.log(error);
      }
    }

    // obtiene consumo para editar
    const obtenerConsumoEd =  consumo => {
      
        dispatch({
          type: OBTENER_CONSUMO_ED,
          payload: consumo
        })
      
    }

    // Edita o modifica un consumo
    const actualizarConsumo = async consumo => {

      try {
        const resultado = await clienteAxios.put(`/api/consumos/${consumo._id}`, consumo);
        //console.log(resultado);
        dispatch({
          type: EDITAR_CONSUMO,
          payload: resultado.data.consumo
      })
      } catch (error) {
        console.log(error);
      }
      
  }


    return (
        <consumoContext.Provider
            value = {{
                
                consumosproyecto: state.consumosproyecto,
                consumoeditar: state.consumoeditar,
                obtenerConsumosPyt,
                agregarConsumo,
                eliminarConsumo,
                obtenerConsumoEd,
                actualizarConsumo
            }}
        >
            {props.children}
        </consumoContext.Provider>
    )
}

export default ConsumoState;